module.exports = __webpack_public_path__ + "static/media/success-scheduled.91023a5c.svg";